import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IPlasiyerTeklifIskontoEkle_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IPlasiyerTeklifIskontoEkle_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GetPTeklifIskontolar: any[];
  GetPTeklifIskontolar_dummy: any[];
  GoBack: any;
  GoBack_dummy: any;
  GenelIskontoPTeklifUpdate: number;
  GenelIskontoPTeklifUpdate_dummy: number;
  TriggerEvent: string;
  TriggerEvent_dummy: string;
  GenelIskonto2PTeklifUpdate: number;
  GenelIskonto2PTeklifUpdate_dummy: number;
  GetIskonto3PTeklifUpdate: number;
  GetIskonto3PTeklifUpdate_dummy: number;
  isComp381693Visible: "visible" | "hidden";
  isComp96681Visible: "visible" | "hidden";
  isComp746909Enabled: "enabled" | "disabled";
  isComp472937Enabled: "enabled" | "disabled";
  isComp99733Enabled: "enabled" | "disabled";
}

export class PlasiyerTeklifIskontoEkle_ScreenBase extends React.PureComponent<
  IPlasiyerTeklifIskontoEkle_ScreenProps,
  any
> {
  ml = [
    {
      Id: "e6553d05-98ae-4ab8-be91-cc851f894a0b",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [
        {
          Id: 441988,
          PropertyName: "label",
          Value: "Close",
          TagName: "Button2_label",
        },
        {
          Id: 240685,
          PropertyName: "value",
          Value: "Discount 1",
          TagName: "Label2_value",
        },
        {
          Id: 428368,
          PropertyName: "value",
          Value: "Discount 2",
          TagName: "Label6_value",
        },
        {
          Id: 966794,
          PropertyName: "value",
          Value: "Discount 3",
          TagName: "Label5_value",
        },
      ],
    },
    {
      Id: "f1e96f18-81d9-6312-1ebe-139d61cd7180",
      Name: "tr_TR",
      ShortName: "Turkish",
      LanguagePhrases: [],
    },
    {
      Id: "cd8e66ca-d8dd-1a05-bdac-f63ba9f6777b",
      Name: "fr_FR",
      ShortName: "French",
      LanguagePhrases: [],
    },
    {
      Id: "ef30cc19-66ab-ea0f-c492-2e57cb69ffd2",
      Name: "es_ES",
      ShortName: "Spanish",
      LanguagePhrases: [],
    },
    {
      Id: "188518b9-5083-4356-ba5b-ecf52d32b935",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 435431, PropertyName: "value", Value: "İskonto Tanımla" },
        {
          Id: 516415,
          PropertyName: "value",
          Value: "Sırasıyla İskonto Uygulayabilirsiniz",
        },
        { Id: 240685, PropertyName: "value", Value: "İskonto 1" },
        { Id: 428368, PropertyName: "value", Value: "İskonto 2" },
        { Id: 966794, PropertyName: "value", Value: "İskonto 3" },
        { Id: 441988, PropertyName: "label", Value: "Kapat" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GetPTeklifIskontolar: [],
      GoBack: "",
      GenelIskontoPTeklifUpdate: 0,
      TriggerEvent: "",
      GenelIskonto2PTeklifUpdate: 0,
      GetIskonto3PTeklifUpdate: 0,
      isComp381693Visible: "hidden",
      isComp96681Visible: "hidden",
      isComp746909Enabled: "disabled",
      isComp472937Enabled: "disabled",
      isComp99733Enabled: "disabled",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight(
        "plasiyerteklifiskontoekle",
        ""
      );
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.PlasiyerTeklifIskontoEklePageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("plasiyerteklifiskontoekle", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("plasiyerteklifiskontoekle", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.PlasiyerTeklifIskontoEklePageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      plasiyerteklifiskontoekle_746909_value:
        this.state.GetPTeklifIskontolar?.at?.(0)?.genelIskonto ?? undefined,
      plasiyerteklifiskontoekle_472937_value:
        this.state.GetPTeklifIskontolar?.at?.(0)?.genelIskonto2 ?? undefined,
      plasiyerteklifiskontoekle_99733_value:
        this.state.GetPTeklifIskontolar?.at?.(0)?.genelIskonto3 ?? undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  PlasiyerTeklifIskontoEklePageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      TeklifNumarasi_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.TeklifNumarasi ??
          this.props.screenInputs.teklifnumarasi,
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "PlasiyerTeklifIskontoEkle/PlasiyerTeklifIskontoEklePageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetPTeklifIskontolar = result?.data.getPTeklifIskontolar;
    stateVars.isComp381693Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetPTeklifIskontolar !== undefined
            ? stateVars.GetPTeklifIskontolar?.length > 0
              ? stateVars.GetPTeklifIskontolar[0].genelIskonto
              : null
            : this.state.GetPTeklifIskontolar?.length > 0
            ? this.state.GetPTeklifIskontolar[0].genelIskonto
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp96681Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetPTeklifIskontolar !== undefined
            ? stateVars.GetPTeklifIskontolar?.length > 0
              ? stateVars.GetPTeklifIskontolar[0].genelIskonto2
              : null
            : this.state.GetPTeklifIskontolar?.length > 0
            ? this.state.GetPTeklifIskontolar[0].genelIskonto2
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp746909Enabled =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetPTeklifIskontolar !== undefined
            ? stateVars.GetPTeklifIskontolar?.length > 0
              ? stateVars.GetPTeklifIskontolar[0].isPlasiyerIskontoGirdi
              : null
            : this.state.GetPTeklifIskontolar?.length > 0
            ? this.state.GetPTeklifIskontolar[0].isPlasiyerIskontoGirdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("False", "string")
      ) === true
        ? "enabled"
        : "disabled";
    stateVars.isComp472937Enabled =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetPTeklifIskontolar !== undefined
            ? stateVars.GetPTeklifIskontolar?.length > 0
              ? stateVars.GetPTeklifIskontolar[0].genelIskonto
              : null
            : this.state.GetPTeklifIskontolar?.length > 0
            ? this.state.GetPTeklifIskontolar[0].genelIskonto
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "enabled"
        : "disabled";
    stateVars.isComp99733Enabled =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetPTeklifIskontolar !== undefined
            ? stateVars.GetPTeklifIskontolar?.length > 0
              ? stateVars.GetPTeklifIskontolar[0].genelIskonto2
              : null
            : this.state.GetPTeklifIskontolar?.length > 0
            ? this.state.GetPTeklifIskontolar[0].genelIskonto2
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "enabled"
        : "disabled";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.PlasiyerTeklifIskontoEklePageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  PlasiyerTeklifIskontoEklePageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.plasiyerteklifiskontoekle_746909_value =
      ReactSystemFunctions.value(
        this,
        stateVars.GetPTeklifIskontolar !== undefined
          ? stateVars.GetPTeklifIskontolar?.length > 0
            ? stateVars.GetPTeklifIskontolar[0].genelIskonto
            : null
          : this.state.GetPTeklifIskontolar?.length > 0
          ? this.state.GetPTeklifIskontolar[0].genelIskonto
          : null
      );

    stateVars.isComp746909Enabled =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetPTeklifIskontolar !== undefined
            ? stateVars.GetPTeklifIskontolar?.length > 0
              ? stateVars.GetPTeklifIskontolar[0].isPlasiyerIskontoGirdi
              : null
            : this.state.GetPTeklifIskontolar?.length > 0
            ? this.state.GetPTeklifIskontolar[0].isPlasiyerIskontoGirdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("False", "string")
      ) === true
        ? "enabled"
        : "disabled";
    formVars.plasiyerteklifiskontoekle_472937_value =
      ReactSystemFunctions.value(
        this,
        stateVars.GetPTeklifIskontolar !== undefined
          ? stateVars.GetPTeklifIskontolar?.length > 0
            ? stateVars.GetPTeklifIskontolar[0].genelIskonto2
            : null
          : this.state.GetPTeklifIskontolar?.length > 0
          ? this.state.GetPTeklifIskontolar[0].genelIskonto2
          : null
      );

    stateVars.isComp472937Enabled =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetPTeklifIskontolar !== undefined
            ? stateVars.GetPTeklifIskontolar?.length > 0
              ? stateVars.GetPTeklifIskontolar[0].genelIskonto
              : null
            : this.state.GetPTeklifIskontolar?.length > 0
            ? this.state.GetPTeklifIskontolar[0].genelIskonto
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "enabled"
        : "disabled";
    stateVars.isComp381693Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetPTeklifIskontolar !== undefined
            ? stateVars.GetPTeklifIskontolar?.length > 0
              ? stateVars.GetPTeklifIskontolar[0].genelIskonto
              : null
            : this.state.GetPTeklifIskontolar?.length > 0
            ? this.state.GetPTeklifIskontolar[0].genelIskonto
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.plasiyerteklifiskontoekle_99733_value = ReactSystemFunctions.value(
      this,
      stateVars.GetPTeklifIskontolar !== undefined
        ? stateVars.GetPTeklifIskontolar?.length > 0
          ? stateVars.GetPTeklifIskontolar[0].genelIskonto3
          : null
        : this.state.GetPTeklifIskontolar?.length > 0
        ? this.state.GetPTeklifIskontolar[0].genelIskonto3
        : null
    );

    stateVars.isComp99733Enabled =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetPTeklifIskontolar !== undefined
            ? stateVars.GetPTeklifIskontolar?.length > 0
              ? stateVars.GetPTeklifIskontolar[0].genelIskonto2
              : null
            : this.state.GetPTeklifIskontolar?.length > 0
            ? this.state.GetPTeklifIskontolar[0].genelIskonto2
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "enabled"
        : "disabled";
    stateVars.isComp96681Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetPTeklifIskontolar !== undefined
            ? stateVars.GetPTeklifIskontolar?.length > 0
              ? stateVars.GetPTeklifIskontolar[0].genelIskonto2
              : null
            : this.state.GetPTeklifIskontolar?.length > 0
            ? this.state.GetPTeklifIskontolar[0].genelIskonto2
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  PlasiyerTeklifIskontoEkleComponent_261763_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, null);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  PlasiyerTeklifIskontoEkleComponent_439632_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Iskonto1Oran_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "plasiyerteklifiskontoekle_746909_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      TeklifNumarasi_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.TeklifNumarasi ??
          this.props.screenInputs.teklifnumarasi,
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "PlasiyerTeklifIskontoEkle/PlasiyerTeklifIskontoEkleComponent_439632_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GenelIskontoPTeklifUpdate =
      result?.data.genelIskontoPTeklifUpdate;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.PlasiyerTeklifIskontoEkleComponent_439632_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  PlasiyerTeklifIskontoEkleComponent_439632_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    await this.PlasiyerTeklifIskontoEklePageInit();

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  PlasiyerTeklifIskontoEkleComponent_381693_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Iskonto1Oran_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "plasiyerteklifiskontoekle_472937_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      TeklifNumarasi_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.TeklifNumarasi ??
          this.props.screenInputs.teklifnumarasi,
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "PlasiyerTeklifIskontoEkle/PlasiyerTeklifIskontoEkleComponent_381693_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GenelIskonto2PTeklifUpdate =
      result?.data.genelIskonto2PTeklifUpdate;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.PlasiyerTeklifIskontoEkleComponent_381693_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  PlasiyerTeklifIskontoEkleComponent_381693_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    await this.PlasiyerTeklifIskontoEklePageInit();

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  PlasiyerTeklifIskontoEkleComponent_96681_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Iskonto1Oran_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "plasiyerteklifiskontoekle_99733_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      TeklifNumarasi_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.TeklifNumarasi ??
          this.props.screenInputs.teklifnumarasi,
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "PlasiyerTeklifIskontoEkle/PlasiyerTeklifIskontoEkleComponent_96681_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetIskonto3PTeklifUpdate = result?.data.getIskonto3PTeklifUpdate;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.PlasiyerTeklifIskontoEkleComponent_96681_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  PlasiyerTeklifIskontoEkleComponent_96681_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    await this.PlasiyerTeklifIskontoEklePageInit();

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  PlasiyerTeklifIskontoEkleComponent_441988_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, null);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.PlasiyerTeklifIskontoEklePageInit();
    }
  }
}
